import { render, staticRenderFns } from "./ProteinComponent.vue?vue&type=template&id=2cf674cb&lang=pug&"
import script from "./ProteinComponent.vue?vue&type=script&lang=js&"
export * from "./ProteinComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports